import React, { useEffect, useRef, useState } from "react";
import { Row, Col, Offcanvas, Button } from "react-bootstrap";
import { FiMenu } from "react-icons/fi";
import Normal from "./Compontes/Normal";
import Multi_Year from "./Compontes/Multi_Year";
import Opening from "./Compontes/Opening";
import Summary from "./Compontes/Summary";
import Ac_Confirmation from "./Compontes/Ac_Confirmation";
import Master_Ac from "./Compontes/Master_Ac";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import {
  AcGroupList,
  FasAcList,
  LedgerMasterAccountList,
  LedgerMasterAC,
  LedgerMultiYear,
  MultiYearFun,
  LedgerNormal,
  Ledgersummary,
  LedgerOpening,
  AccountFun,
  OpeningFun,
  SummaryFun,
  AcConfirmationFun,
  MasterACFun,
} from "../../../../Redux/Slice/Fas/Financial Statement/Ledger/LedgerSlice";

import { format } from "date-fns";
import { enUS } from "date-fns/locale";
import { useLocation, useNavigate } from "react-router-dom";
import FASCalender from "../../../../components/Calendar/FASCalender";
import Calendar from "react-calendar";

import { MdOutlineSystemUpdateAlt } from "react-icons/md";
import FASFilterBox from "../../../../components/FilterBox/FASFilter/FASFilter";
import { Loader } from "../../../../components/Loader/Loader";
import { useTheme } from "../../../../Themecontext/Themecontext";

export const Ledger = () => {
  const dispatch = useDispatch();
  const location = useLocation();
  const navigate = useNavigate();

  const FinancialYear = Cookies.get("FinancialYear");
  const Firm = Cookies.get("Firm");

  const [activeTab, setActiveTab] = useState("Normal");
  const [showFilter, setShowFilter] = useState(false);
  const [selectedYearId, setSelectedYearId] = useState(null);

  const handleClose = () => setShowFilter(false);
  const handleShow = () => setShowFilter(true);

  const { Colourdata, DataMain } = useSelector((state) => state.ClientLogin);

  const { AcGroupListdata, FasAcListdata, LedgerMasterAccountListdata } =
    useSelector((state) => state.LedgerSlice);

  const iscolour = Colourdata?.data?.find((el) => el.ExeName === "NEWFAS");
  const iscolourDark = Colourdata?.data?.find(
    (el) => el.ExeName === "NEWFASDARK",
  );
  const { theme } = useTheme();
  const isdark = theme;

  useEffect(() => {
    dispatch(AcGroupList({ Firm, Year: FinancialYear }));
    dispatch(FasAcList({ Year: FinancialYear, Firm }));
    dispatch(LedgerMasterAccountList({ Firm, Year: FinancialYear }));
  }, [dispatch, Firm, FinancialYear]);

  const [showDatePicker, setShowDatePicker] = useState(false);
  const showDateFilter =
    activeTab === "Normal" ||
    activeTab === "Opening" ||
    activeTab === "SUMMARY" ||
    activeTab === "A/C CONFIRMATION";

  const [dateRange, setDateRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: "selection",
    },
  ]);

  function parseRangeToDates(rangeString) {
    if (!rangeString) return { startDate: null, endDate: null };

    const [startStr, endStr] = rangeString.split(" - ");

    const parseDDMMYYYY = (s) => {
      const [day, month, year] = s.split("/").map(Number);
      return new Date(year, month - 1, day);
    };

    return {
      startDate: parseDDMMYYYY(startStr),
      endDate: parseDDMMYYYY(endStr),
    };
  }

  const isFYDateSet = useRef(false);

  useEffect(() => {
    if (!DataMain || !FinancialYear) return;
    if (isFYDateSet.current) return;

    let matchedYear = null;

    DataMain?.AC_Year_List?.forEach((el) => {
      if (el.AcYearID === Number(FinancialYear)) {
        matchedYear = el.AcYear;
      }
    });

    if (matchedYear) {
      const { startDate, endDate } = parseRangeToDates(matchedYear);

      setDateRange([
        {
          startDate,
          endDate,
          key: "selection",
        },
      ]);

      isFYDateSet.current = true;
    }
  }, [DataMain, FinancialYear]);

  const startDate = dateRange?.[0]?.startDate;
  const endDate = dateRange?.[0]?.endDate;

  const safeFormat = (date) => {
    if (!date || isNaN(new Date(date))) return null;
    return format(new Date(date), "yyyy-MM-dd");
  };

  const [filters, setFilters] = useState({
    accountGroup: [],
    accountName: [],
    year: [],
    masterAccountList: [],
  });




  const [search, setSearch] = useState({
    accountGroup: "",
    accountName: "",
    year: "",
    masterAccountList: "",
  });

  const accountGroupList =
    AcGroupListdata?.data?.map((item) => ({
      label: item?.GroupMstName,
      value: item?.GroupMstID,
    })) || [];

  const accountNameList =
    FasAcListdata?.AllParty?.map((item) => ({
      label: item?.AcName,
      value: item?.AcID,
    })) || [];

  // Voice Assistant Integration
  useEffect(() => {
    if (location.state?.searchParty && accountNameList.length > 0) {
      const searchName = location.state.searchParty.toLowerCase().trim();

      // Dice Coefficient for string similarity
      const getBigrams = (string) => {
        const s = string.toLowerCase().replace(/\s+/g, '');
        const v = [];
        for (let i = 0; i < s.length - 1; i++) {
          v.push(s.slice(i, i + 2));
        }
        return v;
      };

      const stringSimilarity = (str1, str2) => {
        if (str1.length < 2 || str2.length < 2) return 0;
        const pairs1 = getBigrams(str1);
        const pairs2 = getBigrams(str2);
        let union = pairs1.length + pairs2.length;
        let hits = 0;
        for (let x = 0; x < pairs1.length; x++) {
          for (let y = 0; y < pairs2.length; y++) {
            if (pairs1[x] === pairs2[y]) {
              pairs2[y] = null;
              hits++;
              break;
            }
          }
        }
        return (2.0 * hits) / union;
      };

      const cleanString = (str) => {
        return str.replace(/\b(private|limited|pvt|ltd|and|co|company|opening)\b/gi, '').replace(/\s+/g, ' ').trim();
      };

      const cleanedSearch = cleanString(searchName);

      let bestMatch = null;
      let highestScore = 0;

      accountNameList.forEach(a => {
        const accLabel = a.label.toLowerCase();
        const cleanedLabel = cleanString(accLabel);

        let score = 0;

        if (accLabel === searchName) {
          score = 10;
        } else if (accLabel.includes(searchName)) {
          score = 5;
        } else {
          score = stringSimilarity(cleanedSearch, cleanedLabel);

          // Boost if the main starting word matches well
          const searchWords = cleanedSearch.split(' ');
          const labelWords = cleanedLabel.split(' ');
          if (searchWords[0] && labelWords[0] && searchWords[0].length > 2) {
            if (labelWords[0].includes(searchWords[0]) || searchWords[0].includes(labelWords[0])) {
              score += 0.5;
            }
          }
        }

        if (score > highestScore) {
          highestScore = score;
          bestMatch = a;
        }
      });

      // Must have at least 30% similarity score to match
      const matchedAccount = highestScore > 0.3 ? bestMatch : null;

      if (matchedAccount) {
        setFilters(prev => {
          if (!prev.accountName.includes(matchedAccount.value)) {
            const updatedAccounts = [matchedAccount.value];

            const startDateFormatted = safeFormat(startDate);
            const endDateFormatted = safeFormat(endDate);

            if (activeTab === "Normal") {
              dispatch(LedgerNormal({
                Firm,
                Year: FinancialYear,
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
                endDate: endDateFormatted,
              }));
            }

            return { ...prev, accountName: updatedAccounts };
          }
          return prev;
        });

        // Clear state to prevent infinite loops on reload or getting stuck when filtering manually
        navigate(location.pathname, { replace: true, state: {} });
      }
    }
  }, [location.state, accountNameList, startDate, endDate, Firm, FinancialYear, dispatch, activeTab]);


  const yearList =
    DataMain?.AC_Year_List?.map((item) => ({
      label: item?.AcYear,
      value: item?.AcYearID,
    })) || [];

  const masterAccountList =
    LedgerMasterAccountListdata?.MasterAcList?.map((item) => ({
      label: item?.AcMasterName,
      value: item?.AcMasterID,
    })) || [];

  const toggleItem = (type, item) => {
    setFilters((prev) => {
      // if (type === "year") {
      //   dispatch(MultiYearFun());

      //   const isSelected = prev.year.includes(item.value);

      //   const updatedYears = isSelected
      //     ? prev.year.filter((i) => i !== item.value)
      //     : [...prev.year, item.value];

      //   dispatch(
      //     LedgerMultiYear({
      //       Firm,
      //       Year:
      //         updatedYears.join(",") === ""
      //           ? FinancialYear
      //           : updatedYears.join(","),
      //       selectedIds: prev.accountGroup?.join(",") || "",
      //       AcIDs: prev.accountName?.join(",") || "",
      //     }),
      //   );

      //   return {
      //     ...prev,
      //     year: updatedYears,
      //   };
      // }

      if (type === "accountGroup") {
        const isSelected = prev.accountGroup.includes(item.value);

        const updatedGroups = isSelected
          ? prev.accountGroup.filter((i) => i !== item.value)
          : [...prev.accountGroup, item.value];

        dispatch(
          FasAcList({
            Firm: Firm,
            Year: FinancialYear,
            AcGroupIDs: updatedGroups.join(","),

          }),
        );

        return {
          ...prev,
          accountGroup: updatedGroups,
        };
      }

      if (type === "accountName") {
        const isSelected = prev.accountName.includes(item.value);

        const updatedAccounts = isSelected ? [] : [item.value];

        const startDateFormatted = safeFormat(startDate);
        const endDateFormatted = safeFormat(endDate);
        if (!isSelected) {
          if (activeTab === "Normal") {
            dispatch(
              LedgerNormal({
                Firm,
                Year: FinancialYear,
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
                endDate: endDateFormatted,
              }),
            );
          } else if (activeTab === "MULTI YEAR") {
            dispatch(
              LedgerMultiYear({
                Firm,
                Year:
                  prev.year?.join(",") === ""
                    ? FinancialYear
                    : prev.year?.join(","),
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
                endDate: endDateFormatted,
              }),
            );
          } else if (activeTab === "Opening") {
            dispatch(
              LedgerOpening({
                Firm,
                Year: FinancialYear,
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
              }),
            );
          } else if (activeTab === "SUMMARY") {
            dispatch(
              Ledgersummary({
                Firm,
                Year: FinancialYear,
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
                endDate: endDateFormatted,
              }),
            );
          } else if (activeTab === "A/C CONFIRMATION") {
            dispatch(
              LedgerNormal({
                Firm,
                Year: FinancialYear,
                selectedIds: prev.accountGroup?.join(",") || "",
                AcIDs: updatedAccounts.join(","),
                startDate: startDateFormatted,
                endDate: endDateFormatted,
              }),
            );
          }
        }

        return {
          ...prev,
          accountName: updatedAccounts,
        };
      }



      const selected = prev[type];

      return {
        ...prev,
        [type]: selected.includes(item.value)
          ? selected.filter((i) => i !== item.value)
          : [...selected, item.value],
      };
    });
  };


  const handelsubmit = () => {
    dispatch(MultiYearFun());
    setSelectedYearId(filters.year);

    dispatch(
      LedgerMultiYear({
        Firm,
        Year:
          filters.year?.join(",") === ""
            ? FinancialYear
            : filters.year?.join(","),
        selectedIds: filters.accountGroup?.join(",") || "",
        AcIDs: filters.accountName?.join(",") || "",
      }),
    );
  };



  const selectAll = (type, items) => {
    const allIds = items
      .map((i) => i.value)
      .filter((id) => id !== null && id !== undefined && id !== "");

    setFilters((prev) => ({
      ...prev,
      [type]: prev[type].length === allIds.length ? [] : allIds,
    }));
  };

  const handleSearch = (type, value) => {
    setSearch((prev) => ({
      ...prev,
      [type]: value,
    }));
  };

  useEffect(() => {
    dispatch(AccountFun());
    dispatch(MultiYearFun());
    dispatch(OpeningFun());
    dispatch(SummaryFun());
    dispatch(AcConfirmationFun());
    dispatch(MasterACFun());
    if (activeTab !== "MASTER A/C" && filters.accountName.length === 0) return;

    const startDateFormatted = safeFormat(startDate);
    const endDateFormatted = safeFormat(endDate);

    const commonPayload = {
      Firm,
      Year: FinancialYear,
      selectedIds: filters.accountGroup?.join(",") || "",
      AcIDs: filters.accountName.join(","),
      startDate: startDateFormatted,
      endDate: endDateFormatted,
    };

    if (activeTab === "Normal") {
      dispatch(LedgerNormal(commonPayload));
    } else if (activeTab === "MULTI YEAR") {
      dispatch(
        LedgerMultiYear({
          ...commonPayload,
          Year:
            filters.year?.join(",") === ""
              ? FinancialYear
              : filters.year.join(","),
        }),
      );
    } else if (activeTab === "Opening") {
      dispatch(
        LedgerOpening({
          ...commonPayload,
          endDate: undefined,
        }),
      );
    } else if (activeTab === "SUMMARY") {
      dispatch(Ledgersummary(commonPayload));
    } else if (activeTab === "A/C CONFIRMATION") {
      dispatch(LedgerNormal(commonPayload));
    } else if (activeTab === "MASTER A/C") {
      if (filters.masterAccountList.length === 0) return;

      dispatch(
        LedgerMasterAC({
          Firm,
          Year: FinancialYear,
          selectedIds: filters.accountGroup?.join(",") || "",
          AcIDs: filters.masterAccountList.join(","),
          startDate: startDateFormatted,
          endDate: endDateFormatted,
        }),
      );
    }
  }, [
    activeTab,
    filters.accountName,
    filters.accountGroup,
    // filters.year,
    filters.masterAccountList,
    startDate,
    endDate,
  ]);
  const renderPage = () => {
    const commonProps = {
      accountGroup: filters.accountGroup,
      accountName: filters.accountName,
      masterAccountList: filters.masterAccountList,
      startDate: safeFormat(startDate),
      endDate: safeFormat(endDate),

    };

    console.log(activeTab);


    switch (activeTab) {
      case "Normal":
        return <Normal {...commonProps} />;
      case "MULTI YEAR":
        return <Multi_Year {...commonProps} />;
      case "Opening":
        return <Opening {...commonProps} />;
      case "SUMMARY":
        return <Summary {...commonProps} />;
      case "A/C CONFIRMATION":
        return <Ac_Confirmation {...commonProps} />;
      case "MASTER A/C":
        return <Master_Ac {...commonProps} />;
      default:
        return <Normal {...commonProps} />;
    }
  };

  const isLoading =
    !FasAcListdata ||
    !AcGroupListdata ||
    !LedgerMasterAccountListdata ||
    !DataMain;

  if (isLoading) {
    return (
      <div
        className="flex justify-center align-items-center"
        style={{ height: "100vh" }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        padding: "16px",
        background:
          isdark === "light" ? "#f7efdd " : iscolourDark?.Colour2,
        minHeight: "100vh",
      }}
    >
      <style>{`
      .hover-scale-btn {
        transition: transform 0.2s ease-in-out;
        transform: scale(1);
      }
      .hover-scale-btn:hover {
        transform: scale(1.02);
      }
    `}</style>

      <div
        className="d-lg-none"
        style={{
          display: "flex",
          justifyContent: "flex-end",
          marginBottom: "12px",
        }}
      >
        <Button
          onClick={handleShow}
          style={{
            background: isdark === "light" ? iscolour?.Colour1 : iscolourDark?.Colour1,
            border: "none",
            borderRadius: "8px",
            padding: "8px 12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 4px rgba(0,0,0,0.1)"
          }}
        >
          <FiMenu size={22} color={isdark === "light" ? iscolour?.Colour5 : iscolourDark?.Colour8} />
        </Button>
      </div>

      <Row className="g-4 align-items-start ">
        <Col xl={3} lg={4} md={12} sm={12} className="d-none d-lg-block">
          <div
            style={{
              position: "sticky",
              top: "16px",
              display: "flex",
              flexDirection: "column",
              gap: "24px",
            }}
          >
            {showDateFilter && (
              <div>
                <div
                  style={{
                    backgroundColor:
                      isdark === "light"
                        ? iscolour?.Colour5
                        : iscolourDark?.Colour10,
                    padding: "13px 20px",
                    borderRadius: "10px 10px 0px 0px",
                  }}
                >
                  <h3
                    style={{
                      fontWeight: "700",
                      fontSize: "18px",
                      margin: 0,
                      color:
                        isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1,
                      alignItems: "center",
                      display: "flex",
                    }}
                  >
                    Date Range
                  </h3>
                </div>
                <div
                  style={{
                    border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                    padding: "15px",
                    marginBottom: "15px",
                    background:
                      isdark === "light"
                        ? iscolour?.Colour1
                        : iscolourDark?.Colour1,
                    borderRadius: "0px 0px 10px 10px",
                  }}
                >
                  <div
                    onClick={() => setShowDatePicker(true)}
                    style={{
                      marginTop: "8px",
                      padding: "10px",
                      border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                      borderRadius: "8px",
                      cursor: "pointer",
                      color:
                        isdark === "light" ? "#000" : iscolourDark?.Colour11,
                      textAlign: "center",
                    }}
                  >
                    {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                      ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                      : "Select Date Range"}
                  </div>
                </div>
              </div>
            )}
            {activeTab === "MULTI YEAR" && (
              <FASFilterBox
                title="Year"
                items={yearList}
                search={search.year}
                setSearch={(val) => handleSearch("year", val)}
                selectedItems={filters.year}
                toggleItem={(item) => toggleItem("year", item)}
                selectAll={() => selectAll("year", yearList)}
                showSubmitButton={true}
                onSubmit={() => {
                  handelsubmit();
                }}

              />
            )}
            {activeTab === "MASTER A/C" ? (
              <FASFilterBox
                title="Master Account"
                items={masterAccountList}
                search={search.masterAccountList}
                setSearch={(val) => handleSearch("masterAccountList", val)}
                selectedItems={filters.masterAccountList}
                toggleItem={(item) => toggleItem("masterAccountList", item)}
                selectAll={() => selectAll("masterAccountList", masterAccountList.filter(Boolean))}
              />
            ) : (
              <>
                <FASFilterBox
                  title="Account Name"
                  items={accountNameList}
                  search={search.accountName}
                  setSearch={(val) => handleSearch("accountName", val)}
                  selectedItems={filters.accountName}
                  toggleItem={(item) => toggleItem("accountName", item)}
                  selectAll={null}
                  isMulti={false}
                />
                <FASFilterBox
                  title="Account Group"
                  items={accountGroupList}
                  search={search.accountGroup}
                  setSearch={(val) => handleSearch("accountGroup", val)}
                  selectedItems={filters.accountGroup}
                  toggleItem={(item) => toggleItem("accountGroup", item)}
                  selectAll={() => selectAll("accountGroup", accountGroupList)}
                />
              </>
            )}
          </div>
        </Col>

        <Col xl={9} lg={8} md={12} sm={12}>
          <Offcanvas show={showFilter} onHide={handleClose} placement="start">
            <Offcanvas.Header closeButton>
              <Offcanvas.Title>Filters</Offcanvas.Title>
            </Offcanvas.Header>
            <Offcanvas.Body>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: "24px",
                }}
              >
                {showDateFilter && (
                  <div>
                    <div
                      style={{
                        backgroundColor:
                          isdark === "light"
                            ? iscolour?.Colour5
                            : iscolourDark?.Colour10,
                        padding: "13px 20px",
                        borderRadius: "10px 10px 0px 0px",
                      }}
                    >
                      <h3
                        style={{
                          fontWeight: "700",
                          fontSize: "18px",
                          margin: 0,
                          color:
                            isdark === "light"
                              ? iscolour?.Colour1
                              : iscolourDark?.Colour1,
                          alignItems: "center",
                          display: "flex",
                        }}
                      >
                        Date Range
                      </h3>
                    </div>
                    <div
                      style={{
                        border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                        padding: "15px",
                        marginBottom: "15px",
                        background:
                          isdark === "light"
                            ? iscolour?.Colour1
                            : iscolourDark?.Colour1,
                        borderRadius: "0px 0px 10px 10px",
                      }}
                    >
                      <div
                        onClick={() => setShowDatePicker(true)}
                        style={{
                          marginTop: "8px",
                          padding: "10px",
                          border: `2px solid ${isdark === "light" ? iscolour?.Colour4 : iscolourDark?.Colour10}`,
                          borderRadius: "8px",
                          cursor: "pointer",
                          color:
                            isdark === "light"
                              ? "#000"
                              : iscolourDark?.Colour11,
                          textAlign: "center",
                        }}
                      >
                        {dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                          ? `${format(dateRange[0].startDate, "dd-MM-yyyy")} - ${format(dateRange[0].endDate, "dd-MM-yyyy")}`
                          : "Select Date Range"}
                      </div>
                    </div>
                  </div>
                )}
                {activeTab === "MULTI YEAR" && (
                  <FASFilterBox
                    title="Year"
                    items={yearList}
                    search={search.year}
                    setSearch={(val) => handleSearch("year", val)}
                    selectedItems={filters.year}
                    toggleItem={(item) => toggleItem("year", item)}
                    selectAll={() => selectAll("year", yearList)}
                  />
                )}

                <FASFilterBox
                  title="Account Group"
                  items={accountGroupList}
                  search={search.accountGroup}
                  setSearch={(val) => handleSearch("accountGroup", val)}
                  selectedItems={filters.accountGroup}
                  toggleItem={(item) => toggleItem("accountGroup", item)}
                  selectAll={() => selectAll("accountGroup", accountGroupList)}
                />

                <FASFilterBox
                  title="Account Name"
                  items={accountNameList}
                  search={search.accountName}
                  setSearch={(val) => handleSearch("accountName", val)}
                  selectedItems={filters.accountName}
                  toggleItem={(item) => toggleItem("accountName", item)}
                  selectAll={() => selectAll("accountName", accountNameList)}
                  isMulti={false}
                />
              </div>
            </Offcanvas.Body>
          </Offcanvas>

          <Row className="g-2 mb-3">
            {[
              "Normal",
              "MULTI YEAR",
              "Opening",
              "SUMMARY",
              "A/C CONFIRMATION",
              "MASTER A/C",
            ].map((tab, index) => {
              const isActive = activeTab === tab;

              return (
                <Col xl={4} lg={6} md={6} sm={6} xs={12} key={index}>
                  <button
                    onClick={() => setActiveTab(tab)}
                    className="hover-scale-btn"
                    style={{
                      width: "100%",
                      height: "58px",
                      backgroundColor: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour3,
                      border: `2px solid ${isActive
                        ? isdark === "light"
                          ? iscolour?.Colour5
                          : iscolourDark?.Colour10
                        : isdark === "light"
                          ? iscolour?.Colour4
                          : iscolourDark?.Colour10
                        }`,
                      borderRadius: "14px",
                      fontWeight: "bold",
                      color: isActive
                        ? isdark === "light"
                          ? iscolour?.Colour1
                          : iscolourDark?.Colour1
                        : isdark === "light"
                          ? iscolour?.Colour11
                          : iscolourDark?.Colour9,
                      fontSize: "14px",
                    }}
                  >
                    {tab}
                  </button>
                </Col>
              );
            })}
          </Row>

          {renderPage()}
        </Col>
      </Row>
      {showDatePicker && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 99999,
          }}
          onClick={() => setShowDatePicker(false)}
        >
          <FASCalender
            isdark={isdark}
            iscolour={iscolour}
            iscolourDark={iscolourDark}
          />
          <div
            style={{
              background:
                isdark === "light" ? iscolour?.Colour3 : iscolourDark?.Colour3,
              borderRadius: "20px",
            }}
            onClick={(e) => e.stopPropagation()}
          >
            <Calendar
              className="custom-calendar"
              selectRange={true}
              onChange={(value) => {
                if (Array.isArray(value)) {
                  setDateRange([
                    {
                      startDate: value[0],
                      endDate: value[1],
                      key: "selection",
                    },
                  ]);
                }
              }}
              value={
                dateRange?.[0]?.startDate && dateRange?.[0]?.endDate
                  ? [dateRange[0].startDate, dateRange[0].endDate]
                  : null
              }
            />

            <div
              className="date-picker-footer"
              style={{
                textAlign: "center",
                marginTop: "15px",
                padding: "12px",
                background:
                  isdark === "light"
                    ? iscolour?.Colour3
                    : iscolourDark?.Colour3,
                borderRadius: "0 0 20px 20px",
              }}
            >
              <button
                onClick={() => setShowDatePicker(false)}
                style={{
                  padding: "10px",
                  borderRadius: "12px",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "700",
                  color: "#fff",
                  background:
                    isdark === "light"
                      ? iscolour?.Colour12
                      : iscolourDark?.Colour7,
                  boxShadow: "0 4px 10px rgba(0,0,0,0.25)",
                  transition: "0.2s ease",
                }}
                onMouseEnter={(e) => {
                  e.target.style.opacity = "0.85";
                  e.target.style.transform = "scale(1.05)";
                }}
                onMouseLeave={(e) => {
                  e.target.style.opacity = "1";
                  e.target.style.transform = "scale(1)";
                }}
              >
                Done
              </button>
            </div>
          </div>
        </div>
      )}

    </div>
  );
};
